import GeneralDashboardFundraiserDisplay from "../../../components/RefactoredDashboard/GeneralDashboard/GeneralDashboardFundraiserDisplay";
import GeneralDashboardTableView from "../../../components/RefactoredDashboard/GeneralDashboard/DesktopTableView";
import DesktopSidebar from "../../../components/RefactoredDashboard/DesktopSidebar";
import "./DesktopView.css";
import { filterByOptions } from "../GeneralDashboard";
import { useState } from "react";
import {
  FilterFundraisersByEndDate,
  useNavigateToJoinFundraiser,
} from "../../../components/RefactoredDashboard/DashboardCommonFunctions";
import {
  FundraiserForAccount,
  LoggedInAccount,
} from "../../../Interfaces/AccountUsers";
import config from "../../../config";
import { GeneralUserDashboardSidebarActions } from "../../../components/RefactoredDashboard/DesktopSidebarActions";
import FundraisersAwaitingCoordinator from "../../../components/Dashboard/FundraisersAwaitingCoordinator";

interface GeneralDashboardSeparateDesktopViewProps {
  loggedInAccount: LoggedInAccount; // Replace 'any' with the actual type of user account
  fundraisers: FundraiserForAccount[]; // Assuming this is the correct type for active fundraisers
  filterView: string | undefined;
  setFilterView: (option: string | undefined) => void;
  filterBy: string | undefined;
  setFilterBy: (option: string | undefined) => void;
}

const GeneralDashboardSeparateDesktopView: React.FC<
  GeneralDashboardSeparateDesktopViewProps
> = ({
  loggedInAccount,
  fundraisers,
  filterView,
  setFilterView,
  filterBy,
  setFilterBy,
}) => {
  const [useTableView, setUseTableView] = useState<boolean>(false);

  const navigateToJoinFundraiser = useNavigateToJoinFundraiser();

  return (
    <div className="general-dashboard-desktop-container">
      <div className="general-dashboard-sidebar-content">
        <DesktopSidebar
          profileName={
            loggedInAccount.first_name + " " + loggedInAccount.last_name
          }
          actions={GeneralUserDashboardSidebarActions}
        />
      </div>
      <div className="general-dashboard-main-content">
        <div className="general-dashboard-header">
          {config.SITE_NAME}
          <div className="general-dashboard-right-side">
            <button
              className="pill-button"
              onClick={() => {
                setUseTableView(!useTableView);
              }}
            >
              {useTableView ? "Switch to Normal View" : "Switch to Table View"}
            </button>
            <button className="pill-button" onClick={navigateToJoinFundraiser}>
              + Join Fundraiser
            </button>
          </div>
        </div>
        <div className="my-fundraisers-header-row">
          <h2>My Fundraisers</h2>
          <FilterFundraisersByEndDate
            filterView={filterView}
            setFilterView={setFilterView}
          />
          <select
            value={filterBy || ""}
            onChange={(e) => setFilterBy(e.target.value || undefined)}
          >
            {Object.entries(filterByOptions).map(([key, label]) => (
              <option key={key} value={key}>
                {label}
              </option>
            ))}
          </select>
        </div>
        {loggedInAccount.id && (
          <FundraisersAwaitingCoordinator user_id={loggedInAccount.id} />
        )}
        {useTableView ? (
          <GeneralDashboardTableView
            fundraiser={fundraisers}
            isMobile={false}
          />
        ) : (
          <GeneralDashboardFundraiserDisplay fundraisers={fundraisers} />
        )}
      </div>
    </div>
  );
};

export default GeneralDashboardSeparateDesktopView;
